import * as React from "react";
import Panel from "../../Panel";
import VerifyEmailForm from "./VerifyEmailForm";

export default function VerifyEmail() {
  return (
    <Panel>
      <VerifyEmailForm />
    </Panel>
  );
}
